const distanceFromRect = (rect, x, y) => {
  const dx = Math.max(rect.left - x, 0, x - rect.right);
  const dy = Math.max(rect.top - y, 0, y - rect.bottom);
  return dx * dx + dy * dy;
};

// A question can continue in another CSS column. Its bounding box spans both
// pages, so use the fragment under the pointer in viewport (already scaled) units.
export const getHandoutPreviewInsertAfter = (event) => {
  const target = event.currentTarget;
  const fragments = Array.from(target.getClientRects?.() || []).filter(
    (rect) => rect.width > 0 && rect.height > 0,
  );
  const x = event.clientX;
  const y = event.clientY;
  let rect;
  if (Number.isFinite(x) && Number.isFinite(y) && fragments.length) {
    rect = fragments.reduce((nearest, candidate) =>
      distanceFromRect(candidate, x, y) < distanceFromRect(nearest, x, y)
        ? candidate : nearest,
    );
  } else {
    rect = target.getBoundingClientRect();
  }
  return y >= rect.top + rect.height / 2;
};

export const isHandoutPreviewControl = (target) => Boolean(target?.closest?.(
  'button, a, input, textarea, select, [contenteditable="true"], [data-preview-no-drag]',
));
